const skuType = "sku";
const materialType = "material";
const item_types = [{ type: skuType }, { type: materialType }];

export { skuType, materialType, item_types };
